import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'

import { pinContent } from '../api'
import { contentKeys } from '../queryKeys'

const usePinContentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ accountId, contentId }: { accountId: string; contentId: string }) =>
      pinContent({ accountId, contentId }),
    {
      onError: (error: any) => {
        errorToast(error?.response?.data?.message || 'Unable to pin content.')
      },
      onSuccess: () => {
        successToast('Campaign pinned successfully.')
      },
      onSettled: () => {
        queryClient.invalidateQueries(contentKeys.contentLibraryAll())
      },
    }
  )
}

export default usePinContentMutation
